<template lang="pug">
  .building-game
    p5-vue-mirror(:scriptFiles="scriptFiles",
                  :hidecode="true",
                  :headerContent= "headerContent")

</template>

<style lang="sass">
.building-game iframe
  height: 100%
  width: 100%
  position: absolute
  left: 0 
  top: 0
  background-color: #63D1D0
</style>
<script>
export default {
  data(){
    return {
      scriptFiles: [
        'https://cdnjs.cloudflare.com/ajax/libs/matter-js/0.14.2/matter.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.4.2/gsap.min.js',
        '/js/p5.clickable.js',
        '/js/building.js'
      ],
      headerContent: `<link href="https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100;300;400;500;700;900&display=swap" rel="stylesheet">
      <style> 
        body{
          font-family: 'Noto Sans TC';
        }
        .result{
          max-width: 80vw;
          position: fixed;
          bottom: 40px;
          left: 50%;
          transform: translateX(-53%);
          z-index: 100;
          display: flex;
          width: 100%;
          justify-content: center;
          align-items: center;
          transition: opacity 0.5s;
        }
        .result button{
          user-select: none;
          margin: 10px;
          padding: 10px 20px;
          background-color: white;
          border-radius: 50px;
          border: none;
          font-size: 20px;
          cursor: pointer;
          box-shadow: 0px 0px 30px rgba(0,0,0,0.3);
          
        }
        .result button:hover{
          filter: brightness(90%)

        }
        .result button:nth-child(2){
          background-color: #F0815D;
        }

        .result button:nth-child(3):before{
          content: "";
          display: inline-block;
          width: 1.1em;
          height: 1.1em;  
          background-image: url('/img/facebook-xxl.png');
          margin-right: 0.3em;
          background-size: cover;
          vertical-align: middle;
        }
        @media only screen and (max-width: 600px) {
          .result{
            flex-direction: column;
            align-items: center;
            width: 100%;
            max-width: initial;
            transform: translateX(-50%);
            // padding-left: 30px;
            // padding-right: 30px;
          }
          .result button{
            width: calc(100% - 60px);
            margin-bottom: 8px;
          }

        }
      
      
      </style>

      
      `
    }
  },
  mounted(){

    window.document.addEventListener('goBackMain', handleEvent, false)
    function handleEvent(e) {
      window.router.push("/")
      console.log("herihjeoirjh")
    }
  }
}
</script>